import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { Globe, ExternalLink } from "lucide-react";

export default function WebSourcesDrawer({ open, onOpenChange, sources }) {
  const list = sources || [];
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        data-testid="web-sources-drawer"
        className="bg-slate-950 border-slate-800 text-slate-100 w-full sm:max-w-md overflow-y-auto"
      >
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 text-sky-300 font-display">
            <Globe size={18} /> Fontes da web ({list.length})
          </SheetTitle>
        </SheetHeader>
        <p className="text-xs text-slate-500 mt-1 mb-4">
          Resultados usados nesta resposta. Não são guardados na memória — usa a página Fontes para
          guardar o que quiseres.
        </p>
        <div className="space-y-3">
          {list.map((sfc, i) => (
            <a
              key={i}
              href={sfc.url}
              target="_blank"
              rel="noreferrer"
              data-testid="web-source-item"
              className="block p-3 rounded-xl bg-slate-900/60 border border-slate-800 hover:border-sky-500/40 transition-colors"
            >
              <div className="flex items-start justify-between gap-2">
                <span className="text-sm font-semibold text-slate-100 leading-snug">{sfc.titulo}</span>
                <ExternalLink size={14} className="text-slate-500 shrink-0 mt-0.5" />
              </div>
              <span className="text-[11px] text-sky-400/80 font-mono break-all">{sfc.url}</span>
              {sfc.trecho && <p className="text-xs text-slate-400 mt-1.5 leading-relaxed">{sfc.trecho}</p>}
            </a>
          ))}
        </div>
      </SheetContent>
    </Sheet>
  );
}
